import React from "react";
import styled from "styled-components";
import GuaranteedDeparture from "./Labels/GuaranteedDeparture";
import InstantBooking from "./Labels/InstantBooking";

const ActivityPrice = ({
  discount,
  oldPrice,
  price,
  priceFor,
  guaranteedDeparture,
  instantBooking,
  partialPayment,
  currency
}) => {
  let newPriceFor = "";
  if (priceFor === "Per Person") {
    newPriceFor = " / Person";
  } else if (priceFor === "Per Vehicle") {
    newPriceFor = " / Vehicle";
  } else if (priceFor === "Flat Rate") {
    newPriceFor = " Flat";
  } else if (priceFor === "Per Couple") {
    newPriceFor = "/ Couple";
  } else if (priceFor === "Per Boat") {
    newPriceFor = " / Boat";
  } else {
    newPriceFor = "";
  }
  return (
    <Container>
      {discount !== 0 && (
        <Wrapper>
          <OldPrice dangerouslySetInnerHTML={showPrice(oldPrice)} />
          <Discounted>{discount}%</Discounted>
        </Wrapper>
      )}
      {discount === 0 && <StartingText>Starting</StartingText>}
      <Wrapper>
        <meta itemProp="priceCurrency" content={currency.code} />
        <CurrenctPrice
          itemProp="price"
          content={price.substring(currency.icon.length + 1)}
          dangerouslySetInnerHTML={showPrice(price)}
        />
        <PriceType>{newPriceFor}</PriceType>
        <Wrapper style={{ margin: 0 }}>
          {guaranteedDeparture && <GuaranteedDeparture />}
          {instantBooking && <InstantBooking />}
          {/* {guaranteedDeparture && <GuaranteedDeparture/>} */}
        </Wrapper>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: ${props => (props.end ? "flex-end" : "center")};
  margin-top: 0.5rem;
`;
const CurrenctPrice = styled.h3`
  margin: 0;
  color: #33cc99;
  font-weight: 500;
  font-size: 1.2rem;
`;

const OldPrice = styled.h4`
  font-size: 0.7rem;
  font-weight: 400;
  text-decoration: line-through;
  color: #a0a0a0;
  margin: 0;
  height: 1rem;
`;

const Discounted = styled.h4`
  background-color: #fdcd26;
  margin-left: 0.5rem;
  font-size: 0.7rem;
  font-weight: 400;
  border-radius: 5px;
  padding: 0.2rem 0.3rem;
  margin: 0;
  margin-left: 0.5rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PriceType = styled.span`
  font-size: 0.8rem;
  font-weight: 400;
  text-transform: capitalize;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
`;

const StartingText = styled.h5`
  margin: 0;
  font-size: 0.8rem;
  color: #484848;
  font-weight: 400;
  height: 1rem;
`;

function showPrice(price) {
  return { __html: price };
}

// const Labels = styled.div`
//   white-space: nowrap;

// `;
export default ActivityPrice;
